import React from 'react';

// eslint-disable-next-line max-len
const KEMOSABE_LOGO = '/themes/theme/kemosabe/logo.png';

const KemosabeTheme = {
  headerLogo: {
    src: KEMOSABE_LOGO,
    alt: 'Kemosabe Logo',
    size: 30,
  },
  darkLogo: {
    src: KEMOSABE_LOGO,
    alt: 'Kemosabe Logo',
    size: 30,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #000',
    height: 80,
  },
  title: 'Kemosabe',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="30"
        src={KEMOSABE_LOGO} alt="Kemosabe Logo"
      />
      <br /><br />
      <h3>Kemosabe</h3>
    </div>
  ),
  shareSite: 'https://kemosaber.dyzio.co',
};

export default KemosabeTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/kemosabe.js
 **/